import { APIcallerv2 } from './APIcaller';

export const getTurnoverByStoreId = async (storeId, startDate, endDate) =>
  APIcallerv2.apiGet(`/turnover/stores/${storeId}`, { startDate, endDate });

export default {
  getTurnoverByStoreId,
};
